var _G, _Path, _Path2, _Path3, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, LinearGradient, Stop } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
var SvgWalletPlus = function SvgWalletPlus(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.722,
    height: 23.698,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 23.722 23.698"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    filter: "url(#wallet-plus_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#5F4B3D",
    d: "M11.861 0c6.55 0 11.861 5.305 11.861 11.85 0 6.543-5.31 11.848-11.86 11.848C5.31 23.698 0 18.393 0 11.85S5.31 0 11.861 0"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "url(#wallet-plus_svg__b)",
    d: "M11.861 0c6.55 0 11.861 5.305 11.861 11.85 0 6.543-5.31 11.848-11.86 11.848C5.31 23.698 0 18.393 0 11.85S5.31 0 11.861 0"
  }))), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "url(#wallet-plus_svg__c)",
    strokeWidth: 0.653,
    d: "M11.861.326c6.37 0 11.534 5.16 11.534 11.523s-5.163 11.523-11.534 11.523c-6.37 0-11.535-5.16-11.535-11.523C.326 5.485 5.491.326 11.861.326Z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#F7FAF7",
    fillRule: "evenodd",
    d: "M10.99 5.98h1.741v11.74H10.99z",
    clipRule: "evenodd"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fill: "#F7FAF7",
    fillRule: "evenodd",
    d: "M17.94 11.2v1.741H6.2V11.2z",
    clipRule: "evenodd"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "wallet-plus_svg__b",
    x1: 11.861,
    x2: 11.861,
    y1: 0,
    y2: 23.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#31B93E"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.895,
    stopColor: "#047725"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "wallet-plus_svg__c",
    x1: 11.861,
    x2: 11.861,
    y1: 23.698,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#04A131"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#52DF65"
  })))));
};
export default SvgWalletPlus;